module.exports = __webpack_public_path__ + "static/media/31JFA7.bcc827a3.jpg";